import {Pipe, PipeTransform} from "@angular/core";
import {CompanyType} from "../../model/companyType";

@Pipe({name: 'companyType'})
export class CompanyTypePipe implements PipeTransform {
    transform(value: any) {
        return CompanyType[value];
    }
}
